import { Button, Checkbox, Drawer, Hairline, Label, Radio } from "@components";
import { If } from "shared/components/control-statements";
import { BoxTitles } from "../../BoxTitles";

const BroadcastTypes = {
  ALL: "ALL",
  REGIONS: "REGIONS",
};

const BroadcastRegions = [
  { id: "AC", name: "Acre" },
  { id: "AL", name: "Alagoas" },
  { id: "AP", name: "Amapá" },
  { id: "AM", name: "Amazonas" },
  { id: "BA", name: "Bahia" },
  { id: "CE", name: "Ceará" },
  { id: "DF", name: "Distrito Federal" },
  { id: "ES", name: "Espírito Santo" },
  { id: "GO", name: "Goiás" },
  { id: "MA", name: "Maranhão" },
  { id: "MT", name: "Mato Grosso" },
  { id: "MS", name: "Mato Grosso do Sul" },
  { id: "MG", name: "Minas Gerais" },
  { id: "PA", name: "Pará" },
  { id: "PB", name: "Paraíba" },
  { id: "PR", name: "Paraná" },
  { id: "PE", name: "Pernambuco" },
  { id: "PI", name: "Piauí" },
  { id: "RJ", name: "Rio de Janeiro" },
  { id: "RN", name: "Rio Grande do Norte" },
  { id: "RS", name: "Rio Grande do Sul" },
  { id: "RO", name: "Rondônia" },
  { id: "RR", name: "Roraima" },
  { id: "SC", name: "Santa Catarina" },
  { id: "SP", name: "São Paulo" },
  { id: "SE", name: "Sergipe" },
  { id: "TO", name: "Tocantins" },
];

export const BroadcastAudienceForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const type = node.data?.broadcast?.type || null;
  const states = node.data?.broadcast?.states || [];

  const onChangeNode = (broadcast) => {
    onChange({
      ...node,
      data: {
        ...(node.data || {}),
        broadcast: {
          ...(node?.data?.broadcast || {}),
          ...broadcast,
        },
      },
    });
  };

  const isValid = () => {
    if (type === BroadcastTypes.ALL) {
      return true;
    }

    if (type === BroadcastTypes.REGIONS && states.length > 0) {
      return true;
    }

    return false;
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => {
        onClose();
      }}
      footer={
        <Button
          className="w-100"
          design="primary"
          disabled={!isValid()}
          onClick={() => {
            onSave(node);
            onClose();
          }}
        >
          Salvar
        </Button>
      }
      title={BoxTitles.BroadcastAudience}
    >

      <Label>Buscar por</Label>

      <Radio
        family="url"
        className="mb-10"
        value={BroadcastTypes.ALL}
        checked={type}
        onChange={() => onChangeNode({ type: BroadcastTypes.ALL, states: [] })}
      >
        Todas as regiões
      </Radio>
      <Radio
        family="url"
        value={BroadcastTypes.REGIONS}
        checked={type}
        onChange={() => onChangeNode({ type: BroadcastTypes.REGIONS })}
      >
        Regiões específicas
      </Radio>

      <If cond={type === BroadcastTypes.REGIONS}>
        <>
          <Hairline className="mt-20 mb-20" />
          <Label className="mt-20 mb-10">Regiões</Label>
          {BroadcastRegions.map((region) => (
            <Checkbox
              className="mb-15"
              label={region.name}
              checked={states.includes(region.id)}
              onChange={() => {
                if (states.includes(region.id)) {
                  onChangeNode({
                    states: states.filter((state) => state != region.id),
                  });
                } else {
                  onChangeNode({
                    states: [...states, region.id],
                  });
                }
              }}
            />
          ))}
        </>
      </If>
    </Drawer>
  );
};
